import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ChartsService } from "../../charts/charts-services/charts.service";
import {
  OptionGroup,
  Palette,
  PaletteRoles,
} from "../color-themes/color-themes";
import { PaletteType } from "./theme-selector.model";

@Component({
  selector: "app-theme-selector",
  templateUrl: "./theme-selector.component.html",
  styleUrls: ["./theme-selector.component.scss"],
  standalone: false,
})
export class ThemeSelectorComponent implements OnInit {
  @Input() type: PaletteType;
  @Output() selectedPalette = new EventEmitter<Palette>();
  options: OptionGroup[] = [];
  public selected: string;

  constructor(public chartsService: ChartsService) {}

  ngOnInit(): void {
    this.selected = "default_theme";
    this.options = this.chartsService.getThemePalette(this.type).groups;
  }

  select(value: Palette) {
    if (typeof value != "string") {
      this.selectedPalette.emit(value);
      this.selected = value.palette_name;
    }
  }

  showBackground(palette) {
    if (palette?.background) {
      const backgroundEl = palette.colors.find(
        (el) =>
          "roles" in el && el.roles.includes(PaletteRoles.backgroundColor),
      );
      return backgroundEl.hexValue;
    }
  }
}
